import { LinearProgress } from '@mui/material'
import router from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { Root } from './route-progress.styled'

const RouteProgress = () => {
	const [progress, setProgress] = useState(0)
	const [changingRoute, setChangingRoute] = useState(false)
	const timer = useRef()

	useEffect(() => {
		const startLoading = () => {
			setChangingRoute(true)
			setProgress(0)
		}

		const endLoading = () => {
			setProgress(100)
			setChangingRoute(false)
		}

		router.events.on('routeChangeStart', startLoading)
		router.events.on('routeChangeComplete', endLoading)
		router.events.on('routeChangeError', endLoading)

		return () => {
			router.events.off('routeChangeStart', startLoading)
			router.events.off('routeChangeComplete', endLoading)
			router.events.off('routeChangeError', endLoading)
		}
	}, [])

	useEffect(() => {
		if (changingRoute) {
			timer.current = setInterval(() => {
				setProgress((oldProgress) => {
					if (oldProgress === 100) {
						clearInterval(timer?.current) // Disable the timer if the progress is 100%
						return 100
					}
					const diff = Math.random() * 10 // Randomize the progress
					return Math.min(oldProgress + diff, 98) // Reach max 98%
				})
			}, 200) // Update interval
		} else {
			clearInterval(timer?.current)
		}

		return () => {
			clearInterval(timer?.current)
		}
	}, [changingRoute])

	return changingRoute ? (
		<Root>
			<LinearProgress variant="determinate" value={progress} />
		</Root>
	) : null
}

export default RouteProgress
